import React, { useCallback, useEffect } from "react";

import { Navigate, useLocation } from "react-router-dom";
import { cookie } from "../../cookies/cookies";
import { useDispatch, useSelector } from "react-redux";
import { PROFILE_DETAILS } from "../../actions/AuthActions";

const PrivateRoute = () => {
  const isAuthenticated = cookie.get("token");
  const location = useLocation();
  const dispatch = useDispatch();

  const profileDetails = useCallback(
    (values) => {
      dispatch({ type: PROFILE_DETAILS, payload: values });
    },
    [dispatch]
  );
  useEffect(() => {
    if (isAuthenticated) {
      profileDetails();
    }
  }, [isAuthenticated, profileDetails]);
  const profileDetail = useSelector((state) => state?.auth?.profileDetails);
  const isAdmin = profileDetail.user_type === "admin";

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // if user is authenticated, redirect to dashboard page
  if (
    (location.pathname === "/" || location.pathname === "") &&
    isAuthenticated
  ) {
    return (
      <Navigate to={isAdmin ? "/admin/dashboard" : "/dashboard"} replace />
    );
  }
  return <div></div>;
};

export default PrivateRoute;
